import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { clearAuth, getEmail, isAuthenticated } from "../lib/auth";
import { Car, Inbox, LogOut, Plus, LayoutDashboard, Lock, Settings, Banknote, ShieldCheck, Wrench, Mail, Star } from "lucide-react";
import { useEffect } from "react";

export const AdminShell = ({ children, title }) => {
  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    if (!isAuthenticated()) nav("/admin/login");
  }, []);

  const logout = () => {
    clearAuth();
    nav("/admin/login");
  };

  const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, testId: "admin-nav-dashboard" },
    { to: "/admin/cars", label: "Parco Auto", icon: Car, testId: "admin-nav-cars" },
    { to: "/admin/reservations", label: "Prenotazioni", icon: Lock, testId: "admin-nav-reservations" },
    { to: "/admin/sell-offers", label: "Proposte Acquisto", icon: Banknote, testId: "admin-nav-sell-offers" },
    { to: "/admin/insurance", label: "Assicurazione", icon: ShieldCheck, testId: "admin-nav-insurance" },
    { to: "/admin/demolition", label: "Demolizione", icon: Wrench, testId: "admin-nav-demolition" },
    { to: "/admin/requests", label: "Richieste", icon: Inbox, testId: "admin-nav-requests" },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail, testId: "admin-nav-newsletter" },
    { to: "/admin/reviews", label: "Recensioni", icon: Star, testId: "admin-nav-reviews" },
    { to: "/admin/settings", label: "Impostazioni", icon: Settings, testId: "admin-nav-settings" },
  ];

  return (
    <div className="min-h-screen bg-midnight text-white flex flex-col md:flex-row" data-testid="admin-shell">
      <aside className="md:w-64 md:min-h-screen bg-midnight-light border-r border-white/5 flex md:flex-col">
        <div className="p-6 border-b border-white/5 hidden md:block">
          <Logo size="sm" tone="light" />
        </div>
        <nav className="flex md:flex-col p-3 md:p-4 gap-1 flex-1 overflow-x-auto md:overflow-visible">
          {links.map((l) => {
            const active = l.to === "/admin" ? location.pathname === "/admin" : location.pathname.startsWith(l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={l.testId}
                className={`flex items-center gap-3 px-4 py-3 text-sm rounded-sm transition-colors whitespace-nowrap ${
                  active
                    ? "bg-gold text-midnight font-semibold"
                    : "text-white/70 hover:bg-white/5 hover:text-white"
                }`}
              >
                <l.icon size={16} />
                {l.label}
              </Link>
            );
          })}
          <div className="hidden md:block mt-auto pt-4 border-t border-white/5 mt-6">
            <p className="text-[10px] uppercase tracking-widest text-white/30 px-4 mb-2">Connesso come</p>
            <p className="text-xs text-white/60 px-4 mb-3 truncate">{getEmail()}</p>
            <button
              onClick={logout}
              className="w-full flex items-center gap-3 px-4 py-3 text-sm rounded-sm text-white/60 hover:bg-white/5 hover:text-destructive transition-colors"
              data-testid="admin-logout-btn"
            >
              <LogOut size={16} />
              Esci
            </button>
          </div>
        </nav>
      </aside>

      <main className="flex-1 min-w-0">
        <header className="px-6 md:px-10 py-6 border-b border-white/5 flex items-center justify-between">
          <h1 className="font-display text-2xl md:text-3xl font-semibold" data-testid="admin-page-title">
            {title}
          </h1>
          <button
            onClick={logout}
            className="md:hidden text-white/60 hover:text-destructive"
            data-testid="admin-logout-mobile"
          >
            <LogOut size={18} />
          </button>
        </header>
        <div className="p-6 md:p-10">{children}</div>
      </main>
    </div>
  );
};

export default AdminShell;
